/**
 * Returns true if the environment is or production.
 * Roughly, this means the URL does not contain "staging" or "localhost" or "vercel".
 */
export function isProductionLikeUrl(): boolean {
  const { hostname } = window.location

  if (hostname.includes('staging') || hostname.includes('localhost') || hostname.includes('vercel')) {
    return false
  }

  return true
}
